import React from 'react'
import { Table, TableBody, TableCell, TableHead, TableRow, TableContainer, Paper, Tooltip, MenuItem } from '@mui/material'
import { t } from 'i18next'
import { Checkbox } from 'src/Common/ui/checkbox'
// import { formatDate } from 'date-fns'

export default function ReassignTable ({ data, type, selectAll, handleSelectChecked }) {
    const categorizeData = (type) => {
        switch (type) {
        case 'Reassign':
            return data?.filter(ele => ele.checkbox)
        case 'Apply':
            return data
        case 'Acknowledge':
            return data
        default:
            return []
        }
    }
    const transferCondition = (type) => {
        return type === 'transfered'
    }
    return (
        <div style={{ border: '1px solid hsl(var(--popover))', borderRadius: '5px', overflow: 'hidden', width: '100%' }}>
            <TableContainer component={Paper} style={{ maxHeight: '360px', overflow: 'scroll' }}>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow className='bg-white' >
                            { type === 'Apply' && <TableCell className="col-sticky" sx={{ minWidth: '40px', left: 0, zIndex: 10 }}>
                                <div className='flex justify-between'>
                                    <Tooltip title="Select all" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}><div className='mr-1'>
                                        <Checkbox
                                            checked={selectAll}
                                            onCheckedChange={(event) => handleSelectChecked(null, event)}
                                            borderColor='text-primary'
                                        />
                                    </div>
                                    </Tooltip>
                                </div>
                            </TableCell>}

                            <TableCell align='center' style={{ color: 'hsl(var(--primary))', fontSize: '1.1rem', padding: '20px' }} >#</TableCell>
                            <TableCell style={{ color: 'hsl(var(--primary))', fontSize: '1.1rem', padding: '20px' }} >{t('Compliance Title')}</TableCell>
                            <TableCell style={{ color: 'hsl(var(--primary))', fontSize: '1.1rem', padding: '20px' }} >{t('Role')}</TableCell>
                            <TableCell style={{ color: 'hsl(var(--primary))', fontSize: '1.1rem', padding: '20px', textAlign: 'center' }} >{t('Due Date')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {categorizeData(type)?.filter(ele => ele.status !== 'Closed').map((item, index) => (
                            <TableRow key={index}>
                                { type === 'Apply' && <TableCell className='sticky' sx={{ minWidth: '40px', left: 0, zIndex: 1 }}>
                                    <MenuItem className='!p-0' disabled={transferCondition(item?.transferStatus)}>
                                        <Checkbox
                                            checked={item?.checkbox}
                                            onCheckedChange={(event) => handleSelectChecked(item.id, null, item.dueFor)}
                                            borderColor='text-primary'

                                        />
                                    </MenuItem>
                                </TableCell>}
                                <TableCell > <div style={{ fontSize: '1.1rem', backgroundColor: 'hsl(var(--primary-foreground))', color: 'hsl(var(--primary))', borderRadius: '50%', width: '24px', height: '24px', display: 'flex', justifyContent: 'center', alignItems: 'center', margin: 'auto', padding: '20px' }}> {index + 1} </div> </TableCell>
                                <TableCell style={{ fontSize: '1.1rem', padding: '20px' }} >{item?.title}</TableCell>
                                <TableCell align='center' style={{ color: 'hsl(var(--primary))', cursor: 'pointer', textUnderlineOffset: '3px', fontSize: '1.1rem', padding: '20px', whiteSpace: 'nowrap' }} >{
                                    <div className='flex gap-[3px] justify-center'>
                                        {
                                            item?.chipRaciColor?.map((ele) => {
                                                return <>
                                                    <div className={'h-3 flex-shrink-0 flex justify-center items-center w-[12px] text-muted'} style={{ backgroundColor: ele?.color }}>
                                                        <div className='text-[8px]'>
                                                            {ele?.raciLetter}
                                                        </div>
                                                    </div></>
                                            })
                                        }
                                    </div>}</TableCell>
                                <TableCell align='center' style={{ color: 'hsl(var(--destructive))', fontSize: '1.1rem', padding: '20px', whiteSpace: 'nowrap' }}>{item?.dueBy}</TableCell>
                            </TableRow>
                        ))}
                        {
                            !categorizeData(type)
                                ? <TableRow >
                                    <TableCell align='center' colSpan={5}> <div className='text-Extreme'>No Compliance Data</div> </TableCell>
                                </TableRow>
                                : null
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}
